<template>
  <div class="sidebar" data-color="blue_custom">
    <div class="logo">
      <a href="#" class="simple-text logo-normal text-center">
        <img
          id="logoChange"
          src="https://cdn.eurekabookhouse.co.id/ebh/mall/logo_siplah_seller.png"
          style="width: 70%"
          alt=""
        />
      </a>
    </div>
    <div class="sidebar-wrapper" id="sidebar-wrapper">
      <template v-if="isLoggedIn">
        <div class="user">
          <div class="photo" style="background-color: white">
            <img
              v-bind:src="user.image.primary"
              style="
                background-size: contain;
                background-color: white;
                padding: 0px 0px 0px 0px;
              "
            />
          </div>
          <div class="info">
            <a id="sideMallName">
              <span>
                {{
                  user.name
                    .toLowerCase()
                    .split(" ")
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(" ")
                }}
              </span>
            </a>
                <p class="badge badge-soft-dark">Seller</p>
          </div>
        </div>
      </template>

      <ul class="nav">
        <li class="sideTitle">Menu</li>
        <li v-bind:class="$route.path == '/dashboard' ? 'active' : ''">
          <router-link to="/dashboard">
            <i class="changeSize now-ui-icons media-2_sound-wave"></i>
            <p class="changeSizeText">Dashboard</p>
          </router-link>
        </li>

        <li v-bind:class="$route.path == '/profile' ? 'active' : ''">
          <router-link to="/profile">
            <i class="changeSize now-ui-icons users_single-02"></i>
            <p class="changeSizeText">Profile</p>
          </router-link>
        </li>
        <template
          v-if="!user.isMustUpdate || (user.inActive && !user.isBlocked && !user.isBlockedTemporary)"
        >
          <li v-bind:class="$route.path == '/chat' ? 'active' : ''">
            <router-link to="/chat">
              <i class="changeSize now-ui-icons ui-2_chat-round"></i>
              <p class="changeSizeText">
                Chat
                <span
                  class="badge badge-warning float-right mt-2 mr-2"
                  style="width: 20px; font-size: 10px"
                  >{{ alertNotif }}</span
                >
              </p>
            </router-link>
          </li>

          <li v-bind:class="$route.path == '/review' ? 'active' : ''">
            <router-link to="/review">
              <i class="changeSize now-ui-icons ui-2_like"></i>
              <p class="changeSizeText">
                Review Product
                <span
                  class="badge badge-warning"
                  style="width: 20px; margin-left: 123px; font-size: 10px"
                >
                </span>
              </p>
            </router-link>
          </li>

          <li v-bind:class="$route.path == '/pemberitahuan' ? 'active' : ''">
            <router-link to="/pemberitahuan">
              <i class="changeSize now-ui-icons ui-1_bell-53"></i>
              <p class="changeSizeText">Pemberitahuan</p>
            </router-link>
          </li>

          <li v-bind:class="$route.path == '/userlog' ? 'active' : ''">
            <router-link to="/userlog">
              <i class="changeSize now-ui-icons gestures_tap-01"></i>
              <p class="changeSizeText">User Log</p>
            </router-link>
          </li>

          <li class="sideTitle">Pesanan</li>
          <li
            v-bind:class="
              $route.path == '/pesanan' ||
              $route.path == '/pesanan/detail/' + $route.params.id
                ? 'active'
                : ''
            "
          >
            <router-link
              to="/pesanan"
              data-toggle="tooltip"
              data-placement="top"
              title="Anda Mempunyai  Pesanan Baru"
            >
              <i class="changeSize now-ui-icons shopping_cart-simple"></i>
              <p class="changeSizeText">
                Pesanan

                <span
                  v-if="order.items && order.items.lemgth !== 0"
                  class="badge badge-warning float-right mt-2 mr-2"
                  style="width: 20px; font-size: 10px"
                  >{{ order.items.length }}</span
                >
              </p>
            </router-link>
          </li>

          <li v-bind:class="$route.path == '/changeorder' ? 'active' : ''">
            <router-link to="/changeorder">
              <i class="changeSize now-ui-icons shopping_cart-simple"></i>
              <p class="changeSizeText">
                Perubahan Pesanan
                <span
                  class="badge badge-warning float-right mt-2 mr-2"
                  style="width: 20px; font-size: 10px"
                  >{{ countOrderChange }}</span
                >
              </p>
            </router-link>
          </li>

          <li hidden v-bind:class="$route.path == '/penagihan' ? 'active' : ''">
            <router-link to="/penagihan">
              <i class="changeSize now-ui-icons shopping_credit-card"></i>
              <p class="changeSizeText">
                Penagihan
                <!-- <span
                class="badge badge-info text-dark float-right mr-3 mt-2"
                style="font-size: 9.5px"
                >Beta</span
              > -->
              </p>
            </router-link>
          </li>

          <li v-bind:class="$route.path == '/pembayaran/semuapembayaran' ? 'active' : ''">
            <router-link to="/pembayaran/semuapembayaran">
              <i class="changeSize now-ui-icons shopping_credit-card"></i>
              <p class="changeSizeText">
                Pembayaran
              </p>
            </router-link>
          </li>

          <!-- <li
            v-bind:class="
              $route.path == '/pembayaran' ||
              $route.path == '/pembayaran/semuapembayaran' ||
              $route.path == '/pembayaran/kuranglengkap' ||
              $route.path == '/pembayaran/verifikasi' ||
              $route.path == '/pembayaran/diteruskan'
                ? 'active'
                : ''
            "
          >
            <a data-toggle="collapse" href="#pembayaran">
              <i class="changeSize now-ui-icons business_money-coins"></i>
              <i
                class="fas fa-angle-double-down arrowIcon"
                hidden=""
                style="font-size: 12px"
              ></i>

              <p class="changeSizeText">
                Pembayaran
                <b class="caret"></b>
              </p>
            </a>

            <div
              class="collapse"
              id="pembayaran"
              style="background-color: #2a3042"
            >
              <ul class="nav py-1 ml-2 uLpembayaran">
                <li
                  v-bind:class="
                    $route.path == '/pembayaran/semuapembayaran' ? 'active' : ''
                  "
                >
                  <router-link to="/pembayaran/semuapembayaran">
                    <p class="" id="semua">
                      <i class="fas fa-receipt mr-3"></i> Semua Pembayaran
                    </p>
                  </router-link>
                </li>
              </ul>
            </div>
          </li> -->

          <li class="sideTitle">Lainnya</li>
          <li
            v-bind:class="
              $route.path == '/product' ||
              $route.path == '/product/addproduct' ||
              $route.path == '/product/detail/' + $route.params.id
                ? 'active'
                : ''
            "
          >
            <router-link to="/product">
              <i class="changeSize now-ui-icons shopping_box"></i>
              <p class="changeSizeText">Produk</p>
            </router-link>
          </li>

          <li v-bind:class="$route.path == '/ekspedisi' ? 'active' : ''">
            <router-link to="/ekspedisi">
              <i class="changeSize now-ui-icons shopping_delivery-fast"></i>
              <p class="changeSizeText">Ekspedisi</p>
            </router-link>
          </li>

          <li
            v-bind:class="
              $route.path == '/negoisasi' ||
              $route.path == '/negoisasi/detail/' + $route.params.id
                ? 'active'
                : ''
            "
          >
            <router-link to="/negoisasi">
              <i class="changeSize now-ui-icons design_scissors"></i>
              <p class="changeSizeText">Negosiasi</p>
            </router-link>
          </li>

          <li
            v-bind:class="
              $route.path == '/komplain' ||
              $route.path == '/komplain/detail/' + $route.params.id
                ? 'active'
                : ''
            "
          >
            <router-link to="/komplain">
              <i class="changeSize now-ui-icons business_bulb-63"></i>
              <p class="changeSizeText">Komplain</p>
            </router-link>
          </li>
        </template>
      </ul>
      
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
// import axios from "axios";
// import $ from 'jquery'
export default {
  props: {
    alertNotif: Number,
  },
  data() {
    return {
      countOrderChange: 0,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      order: "order",
      user: "user",
      countChat: "countChat",
    }),
  },
  created() {
    this.countChangeOrder();
  },
  methods: {
    countChangeOrder() {
      const params = `?page=${1}&limit=${100}&filter_status=&sort=`;
      let orderUrl = `seller/order/changed${params}`;
      axios
        .get(orderUrl)
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.countOrderChange = data.data.data.items.length;
        });
    },
  },
};
</script>

